import React from 'react';
import './Page404.css'; // Importing the CSS file for styling
import { Link } from 'react-router-dom';

const Page404 = () => {
    return (
        <div className="page-404-container">
            <h1 className="page-404-title">404</h1>
            <p className="page-404-message">Oops! The page you're looking for doesn't exist.</p>
            <Link to={"/"} className="page-404-link">Go Back Dashboard</Link>
        </div>
    );
};

export default Page404;
